import {ApplicationConfiguration} from './application-configurations';
import {baseBackendConfiguration, baseFrontendConfiguration, fnolPublishedFormsBackend} from './base-environment';
import {buildInfo} from './build-info';

export const environment: ApplicationConfiguration = {
  production: false,
  oidc: {
    authority: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_uwLCeZaYV",
    client_id: "32he4ha62h23pgqsf9divcklto",
    redirect_uri: "https://fnol-app.dev.pxcatclaim.com/callback",
    post_logout_redirect_uri: "https://fnol-app.dev.pxcatclaim.com/",
    response_type: "code",
    scope: "profile email openid",
    automaticSilentRenew: true,
    loadUserInfo: true
  },
  claimManagerBackend: {
    ...baseBackendConfiguration,
    baseUrl: 'https://fnol-api.dev.pxcatclaim.com',
  },
  claimManagerFrontend: {
    ...baseFrontendConfiguration,
    baseUrl: 'https://fnol-app.dev.pxcatclaim.com',
  },
  fnolPublishedFormsBackend: {...fnolPublishedFormsBackend, baseUrl: 'https://forms-fnol-app.dev.pxcatclaim.com'},
  buildInfo: {
    commitId: buildInfo.commitId,
    buildDate: buildInfo.buildDate,
    version: buildInfo.version
  }
};
